import { Dialog, Slide } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Search } from '@material-ui/icons';
import { getStudentGoal, getInfosIndividual } from '@webapps/business';
import {
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import Detailed from 'pages/Cvtheque/Components/detailed';

const StudentDetail = ({ student, setSelectedStudent }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [open, setOpen] = useState(false);

  const { data: info = {} } = useQuery(getInfosIndividual, {
    key: ['indivudualInfos', student.id],
    variables: { id: student.id },
  });

  const closeModal = () => {
    setOpen(false);
    setSelectedStudent(null);
  };
  
  useEffect(() => {
    if (info?.id) {
      setOpen(true);
    }
  }
  , [info]);

  return (
    <div className={classes.container}>
      <Grid container>
        <Grid
          xs={12}
          className={classes.details}
        >
          <Slide direction="left" in={info?.id ? true : false} mountOnEnter unmountOnExit timeout={{ enter: 300, exit: 300 }} key={info?.id}>
            <div>
              <Detailed info={info} shareClassroom={true} />
            </div>
          </Slide>
        </Grid>
        <Dialog
          fullScreen
          className={classes.detailsModal}
          onClose={closeModal}
          open={open}
        >
          <Detailed info={info} shareClassroom={true} closeModal={closeModal} />
        </Dialog>
      </Grid>
    </div>
  );
};

const StudentGoal = ({ id, style, textStyle }) => {
  const {
    css,
    classes,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);
  const { data: myGoal = [] } = useQuery(getStudentGoal, {
    key: ['myGoal', id],
    variables: { id },
  });

  const getLabel = (label) => {
    switch (label) {
      case 'Trouver un stage':
        return 'En recherche de stage';
      case 'Trouver une alternance':
        return "En recherche d'une alternance";
      case 'Trouver une formation':
        return "En recherche d'une formation";
      case 'Trouver une formation et un stage':
        return "En recherche d'une formation et d'un stage";
      case 'Trouver une formation et une alternance':
        return "En recherche d'une formation et d'une alternance";
      default:
        return 'En recherche : Non renseigné';
    }
  };

  return (
    <div className={cx(global.infoText, classes.address)}>
      <Search className={global.smallIcon} style={style} />
      <div style={textStyle}>{getLabel(myGoal?.label)}</div>
    </div>
  );
};

StudentGoal.propTypes = {
  id: PropTypes.string,
};

const styles = ({ spacing }) => ({
  container: {
    '@media only screen and (max-width:1023px)': {
      display: 'flex',
      alignItems: 'flex-end',
    },
    width: '100%',
    height: '100%',
  },
  avatar: {
    height: 70,
    width: 70,
  },
  details: {
    overflowY: 'auto',
    background: 'white',
    maxHeight: 'calc(100vh - 178px)',
    '@media only screen and (max-width:1023px)': { display: 'none' },
  },
  detailsModal: {
    display: 'flex',
    alignItems: 'flex-end',
    '@media only screen and (min-width:1023px)': { display: 'none' },
  },
  address: {
    lineHeight: '110%',
    margin: 5,
    display: 'flex',
    alignItems: 'top',
  },
  displayDesktop: {
    padding: spacing(2.5),
    cursor: 'pointer',
    display: 'flex',
    alignItems: ' center',
  },
  desktop: { '@media only screen and (max-width:1023px)': { display: 'none' } },
  displayMobile: {
    border: '1px solid #F3F7FF',
    '@media only screen and (min-width:1025px)': { display: 'none' },
    marginBottom: spacing(2),
    backgroundColor: 'white',
    borderRadius: 10,
  },
});

StudentDetail.propTypes = {
  student: PropTypes.object,
};

export default StudentDetail;
